/* eslint-disable indent */
import styled, { css } from 'styled-components';

const headerButton = css`
    background: transparent none;
    border: 0;
    color: inherit;
    display: inline-flex;
    font-size: inherit;
    margin: 0;
    outline: none;
    padding: 0;
    &:not(:first-child) {
        margin-left: ${({ theme }) => 2 * theme.gridGutterWidth}px;
    }
    ${({ skin }) => skin === 'dark' ? 'opacity: 0.5;' : ''}
    color: var(--attachments-text-active);
    &:hover {
        ${({ skin }) => skin === 'dark' ? `opacity: 1;` : ``}
    }
    &:focus { outline: none; }
    /* Visual tweaks due to different icon sets */
    .glyphicon, .ico-product, .inx-io-icon { font-size: inherit; }
    .glyphicon {
        font-size: 0.85em;
        top: 0;
    }
    .ico-product {
        font-size: 0.95em;
        height: 1.1em;
    }
    &.btn-close {
        --bs-btn-close-opacity: 1;
        .inx-io-icon {
            font-size: 3rem;
            margin-left: -8px;
            margin-right: -10px;
            margin-top: -7px;
            color: var(--color-lake-soft);
            &:hover {
                color: var(--attachments-text-active);
            }
        }
    }
`;

export const Card = styled.div`
    display: flex;
    flex-direction: column;
    height: calc(100vh - var(--gallery-header-height));
    margin: 0 auto;
    max-height: 100vh;
    ${({ theme: { panel }}) => panel.width !== 'auto'
        ? `width: ${panel.width}px`
        : 'width: auto'
    };
    
`;

export const Header = styled.header`
    align-items: center;
    display: flex;
    flex-shrink: 0;
    justify-content: space-between;
    line-height: 1;
    height: var(--gallery-header-height);
    padding: 0 .4em;
    color: ${({ skin }) => skin === 'dark'
        ? `var(--color-white)`
        : `var(--color-lake-soft)`
    };
    ${({ theme }) => `
        min-height: ${15 + theme.fontSize}px;
    `}
`;

export const Title = styled.h2`
    font-size: 2rem;
    line-height: 3rem;
    font-weight: bold;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
`;

export const HeaderButtons = styled.div`
    align-items: center;
    display: inline-flex;
    flex-shrink: 0;
    font-size: 2.2em;
    line-height: 2.2em;
    margin: 0;
    padding-left: ${({ theme }) => theme.gridGutterWidth}px;
    color: ${({ skin }) => skin === 'dark'
        ? `var(--color-white)`
        : `var(--color-lake-soft)`
    };
    button { ${headerButton} }
    .ico-product { margin: 0; }
`;

export const HeaderButton = styled.button`
    ${headerButton}
`;

export const Body = styled.div`
    flex: 1;
    overflow: hidden;
    overflow-y: auto;
    height: calc(100vh - var(--gallery-header-height));
    ${({ isContentLoading }) => isContentLoading
        ? `
            align-items: center;
            display: flex;
            flex-direction: column;
            justify-content: center;
        ` : ''
    }
`;
